import { Component, inject, Input, OnInit } from '@angular/core';
import { QuoteReferenceService } from 'src/app/services/quote-reference.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})
export class HeaderComponent implements OnInit{

  private quoteReferenceService = inject(QuoteReferenceService)

  @Input() brokerId: string = ''
  quoteReference: string = ""
  

  ngOnInit(): void {
    this.quoteReferenceService.quoteReference.subscribe((value: string)=>{

      this.quoteReference = value

    })
  }

  redirectToPortal(){

    var portalUrl = ''

    if(this.brokerId == '01'){
      portalUrl = environment.chill.portalAddress
    }
    else if(this.brokerId == '04'){
      portalUrl = environment.quoteDevil.portalAddress
    }

     window.location.href = portalUrl;

  }

}
